// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5148":"55eff47b","5622":"e9066fd1"}[chunkId] + ".chunk.css";
};